import { h } from 'preact'; /** @jsx h */
import './generalComponentsButtons.scss';

export const Button = (props) => {
    const { label, className, type } = props;
    return (
        <button
            {...props}
            type={type || 'button'}
            className={`${className} btnsDefine`}
        >
            {label}
            {props.children}
        </button>
    );
};
export const GhostBtn = (props) => (
    <Button {...props} className={`btn-hollow ${props.className || ''}`} />
);

export const ViewSelBtn = (props) => (
    <Button {...props} className={`btn-viewing ${props.className || ''}`} />
);

export const SubmitBtn = (props) => (
    <Button
        type="submit"
        {...props}
        className={`submit-btn${props.className ? ` ${props.className}` : ''}`}
    />
);

export const SecondaryBtn = (props) => (
    <Button
        {...props}
        className={`btn-secondary${
            props.className ? ` ${props.className}` : ''
        }`}
    />
);

export const DeleteBtn = (props) => (
    <Button
        {...props}
        className={`btn-delete${props.className ? ` ${props.className}` : ''}`}
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
        </svg>
    </Button>
);

export const BtnPersonModal = (props) => (
    <Button
        {...props}
        className={`btn-showperson${
            props.className ? ` ${props.className}` : ''
        } ${props.active ? 'calendarPersonActive' : ''}`}
    />
);

export const HideViewBtn = (props) => (
    <Button
        {...props}
        className={`btn-hide-show-view${
            props.className ? ` ${props.className}` : ''
        }`}
    />
);

export const LinkBtnStyled = (props) => {
    const { label, href, className } = props;
    return (
        <a {...props} href={href} className={`${className || ''} btnsDefine`}>
            {label}
        </a>
    );
};

export const HollowLinkBtn = (props) => (
    <LinkBtnStyled
        {...props}
        className={`hollow-link-btn ${props.className}`}
    />
);
